/**
 * Image Hotspot content validator
 * Validates image hotspot data for required fields
 */

import type { ContentValidator, ValidationResult } from '@ai-content-hub/content-core';
import { getBackgroundImageSrc } from '@ai-content-hub/content-elements';
import type { ImageHotspotData } from './schema';

export const imageHotspotValidator: ContentValidator<ImageHotspotData> = {
    validate(data: ImageHotspotData): ValidationResult {
        const errors: ValidationResult['errors'] = [];

        if (!data?.title?.trim()) {
            errors.push({ field: 'title', message: 'Title is required.' });
        }

        // Background image is required before objects/zones can be added
        const bgSrc = getBackgroundImageSrc(data?.colorDropZoneData?.background);
        if (!bgSrc) {
            errors.push({
                field: 'colorDropZoneData.background',
                message: 'Vui lòng tải lên ảnh nền trước khi thêm đối tượng.',
            });
        }

        const zones = data?.colorDropZoneData?.zones ?? [];
        if (zones.length === 0) {
            errors.push({
                field: 'colorDropZoneData.zones',
                message: 'Phải vẽ ít nhất 01 vùng nhận diện (Hotspot) trên ảnh.',
            });
        }

        const objects = data?.colorDropZoneData?.objects ?? [];
        if (objects.length === 0) {
            errors.push({ field: 'colorDropZoneData.objects', message: 'At least one object is required.' });
        }

        const palette = data?.colorDropZoneData?.colorPalette ?? [];
        if (palette.length === 0) {
            errors.push({ field: 'colorDropZoneData.colorPalette', message: 'At least one color is required.' });
        }

        return { isValid: errors.length === 0, errors };
    },
};
